// import { MASTER_PAGE_LOAD, MASTER_PAGE_LOAD_SUCCESS, MASTER_PAGE_LOAD_FAIL } from './actions';
import { GET_DELIVERY_OPTION_LOAD, GET_DELIVERY_OPTION_LOAD_SUCCESS, GET_DELIVERY_OPTION_LOAD_FAIL, DAY_NOT_APPLICABLE_LOAD, DAY_NOT_APPLICABLE_LOAD_SUCCESS, DAY_NOT_APPLICABLE_LOAD_FAIL, TEMPRORPY_ADDRESS_PREFERENCE_CHANGES, REMOVE_TEMPRORPY_ADDRESS_PREFERENCE_CHANGES, ADDRESS_PREFERENCE_CHANGES, WAPTEMPRORPY_ADDRESS_PREFERENCE_CHANGES } from './actions';

const initialState = {
  loaded: false,
  editing: {},
  saveError: {},
  data: { originalDeliveryDayPreferences: {}, deliveryDayPreference: {}, originalDeliveryDayNotApplicables: {}, deliveryDayNotApplicables: {} },
  extraData: {},
};

export default function giftPreferences(state = initialState, action = {}) {
  switch (action.type) {
    case GET_DELIVERY_OPTION_LOAD:
      return {
        ...state,
        loading: true,
      };
    case GET_DELIVERY_OPTION_LOAD_SUCCESS: {
      const a = JSON.stringify(action.result);
      return {
        ...state,
        loading: false,
        loaded: true,
        data: { ...state.data,
          originalDeliveryDayPreferences: JSON.parse(a),
          deliveryDayPreference: JSON.parse(a),
        },
        error: null,
        extraData: 'This is extra info..........',
      };
    }
    case GET_DELIVERY_OPTION_LOAD_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: null,
        error: action.error,
      };
    case DAY_NOT_APPLICABLE_LOAD:
      return {
        ...state,
        loading: true,
      };
    case DAY_NOT_APPLICABLE_LOAD_SUCCESS: {
      const a = JSON.stringify(action.result);
      return {
        ...state,
        loading: false,
        loaded: true,
        data: { ...state.data,
          originalDeliveryDayNotApplicables: JSON.parse(a),
          deliveryDayNotApplicables: JSON.parse(a),
        },
        error: null,
        extraData: 'This is extra info..........',
      };
    }
    case DAY_NOT_APPLICABLE_LOAD_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: null,
        error: action.error,
      };
    case TEMPRORPY_ADDRESS_PREFERENCE_CHANGES :
      return {
        ...state,
        data: { ...state.data,
          deliveryDayPreference: {
            ...state.data.deliveryDayPreference,
            preferredDeliveryDayDetails: {
              ...state.data.deliveryDayPreference.preferredDeliveryDayDetails,
              deliveryDayAndAddressInfo: JSON.parse(JSON.stringify(action.payload)),
            },
          },
        },
      };
    case ADDRESS_PREFERENCE_CHANGES :
      return {
        ...state,
        data: {
          ...state.data,
          originalDeliveryDayPreferences: JSON.parse(JSON.stringify(action.payload)),
          deliveryDayPreference: JSON.parse(JSON.stringify(action.payload)),
        },
      };
    case REMOVE_TEMPRORPY_ADDRESS_PREFERENCE_CHANGES:
      return {
        ...state,
        data: { ...state.data,
          deliveryDayPreference: JSON.parse(JSON.stringify(state.data.originalDeliveryDayPreferences)),
        },
      };
    case WAPTEMPRORPY_ADDRESS_PREFERENCE_CHANGES :
      return {
        ...state,
        data: { ...state.data,
          deliveryDayPreference: {
            ...state.data.deliveryDayPreference,
            preferredDeliveryDayDetails: {
              ...state.data.deliveryDayPreference.preferredDeliveryDayDetails,
              deliveryDayAndAddressInfo: JSON.parse(JSON.stringify(action.payload)),
            },
          },
        },
      };
    default:
      return state;
  }
}
